const labels = {
    en: {
        aboutTitle: 'About',
        companyPerformanceTitle: 'Company Performance',
        companyFacts: 'Company facts',
        showAllPhotos: 'Show all photos',
        highlightsTitle: 'Highlights',
        benefitsTitle: 'Benefits',
        testimonialsTitle: 'What our team says',
        openPositionsTitle: 'Open Positions',
        allJobsButton: 'All Jobs',
        storiesTitle: 'Stories',
        storyLinkLabel: 'Link',
    },
    de: {
        aboutTitle: 'Über uns',
        companyPerformanceTitle: 'Unternehmensleistung',
        companyFacts: 'Unternehmensdaten',
        showAllPhotos: 'Alle Fotos anzeigen',
        highlightsTitle: 'Höhepunkte',
        benefitsTitle: 'Benefits',
        testimonialsTitle: 'Was unser Team sagt',
        openPositionsTitle: 'Offene Stellen',
        allJobsButton: 'Zu allen Jobs',
        storiesTitle: 'Stories',
        storyLinkLabel: 'Link',
    },
};
export default labels;
